import React from "react";
import {NavLink} from "react-router-dom";
import List from "./List";

export default ({mapData, infoData, resourceMaterials, meetingData, isEnglish, district}) => {
    let months = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec"
    };

    let mapInfoData = mapData && infoData && [...mapData, ...infoData];
    return (
        <div className="no-bckg">
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <div className="panel panel-primary">
                            <div className="panel-heading">
                                <h4 className="panel-title">
                                    <a href="#">
                                        Maps and Infographics
                                    </a>
                                    <a className="float-right"
                                       href={`/maps-infographics/district/${district}`}
                                       style={{
                                        fontSize: '12px',
                                        marginLeft: '60px',
                                        color:"#fff",
                                        display:"inline"
                                    }}>view all</a>
                                </h4>
                                {mapInfoData && mapInfoData.length > 1 && (
                                    <div>
                                        <a
                                            className="left carousel-control"
                                            href="#carousel-example-generic"
                                            role="button"
                                            data-slide="prev"
                                        >
                                            <img src="/img/arrow.png" alt=""/>
                                        </a>

                                        <a
                                            className="right carousel-control"
                                            href="#carousel-example-generic"
                                            role="button"
                                            data-slide="next"
                                        >
                                            <img src="/img/left.png" alt=""/>
                                        </a>
                                    </div>
                                )}
                            </div>
                            <div className="panel-body">
                                <div
                                    id="carousel-example-generic"
                                    className="carousel slide"
                                    data-ride="carousel"
                                    data-interval="false"
                                >
                                    <div className="carousel-inner" role="listbox">
                                        {mapInfoData && mapInfoData.map((data, i) => (
                                            <div
                                                className={i === 0 ? "item active jpt" : "item jpt"}
                                                key={"main" + i}
                                            >
                                                <ul className="list-unstyled">
                                                    {data.map(d => (
                                                        <List
                                                            key={d.id}
                                                            file={d.file_path}
                                                            img={d.image_path}
                                                            title={isEnglish ? d.title : d.title_nepali}
                                                            date={d.published_date}
                                                        />
                                                    ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-12 col-sm-4">
                        <div className="panel panel-primary">
                            <div className="panel-heading">
                                <h4 className="panel-title">
                                    <a href="#">Resources/Materials</a>
                                    <a className="float-right"
                                       href="/hrrp-reference-library"
                                       style={{
                                        fontSize: '12px',
                                        marginLeft: '80px',
                                        color:"#fff",
                                        display:"inline"
                                    }}>view all</a>
                                </h4>
                                {resourceMaterials && resourceMaterials.length > 1 && (
                                    <div>
                                        <a
                                            className="left carousel-control"
                                            href="#carousel-example-generic1"
                                            role="button"
                                            data-slide="prev"
                                        >
                                            <img src="/img/arrow.png" alt=""/>
                                        </a>

                                        <a
                                            className="right carousel-control"
                                            href="#carousel-example-generic1"
                                            role="button"
                                            data-slide="next"
                                        >
                                            <img src="/img/left.png" alt=""/>
                                        </a>
                                    </div>
                                )}
                            </div>
                            <div className="panel-body">
                                <div
                                    id="carousel-example-generic1"
                                    className="carousel slide"
                                    data-ride="carousel"
                                    data-interval="false"
                                >
                                    <div className="carousel-inner" role="listbox">
                                        {resourceMaterials && resourceMaterials.map((data, i) => (
                                            <div
                                                className={i === 0 ? "item active jpt" : "item jpt"}
                                                key={"main" + i}
                                            >
                                                <ul className="list-unstyled">
                                                    {data.map(d => (
                                                        <List
                                                            key={d.id}
                                                            img={d.image_path}
                                                            title={isEnglish ? d.title : d.title_nepali}
                                                            date={d.published_date}
                                                            file={d.file_path}
                                                        />
                                                    ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-12 col-sm-4">
                        <div className="panel panel-primary">
                            <div className="panel-heading">
                                <h4 className="panel-title">
                                    <a href="#">up coming meeting & events</a>
                                    <a className="float-right"
                                       href={`/recent-minutes/district/${district}`}
                                       style={{
                                        fontSize: '12px',
                                        marginLeft: '20px',
                                        color:"#fff",
                                        display:"inline"
                                    }}>view all</a>
                                </h4>
                                {meetingData &&
                                meetingData.length > 1 && (
                                    <div>
                                        <a
                                            className="left carousel-control"
                                            href="#carousel-example"
                                            role="button"
                                            data-slide="prev"
                                        >
                                            <img src="/img/arrow.png" alt=""/>
                                        </a>

                                        <a
                                            className="right carousel-control"
                                            href="#carousel-example"
                                            role="button"
                                            data-slide="next"
                                        >
                                            <img src="/img/left.png" alt=""/>
                                        </a>
                                    </div>
                                )}
                            </div>

                            <div className="panel-body">
                                <div
                                    id="carousel-example"
                                    className="carousel slide"
                                    data-ride="carousel"
                                    data-interval="false"
                                >
                                    <div className="carousel-inner" role="listbox">
                                        {meetingData && meetingData.map((data, i) => (
                                            <div
                                                className={i === 0 ? "item active jpt" : "item jpt"}
                                                key={"main" + i}
                                            >
                                                {data.map(d => (
                                                    <div className="event-wrapper" key={d.id}>
                                                        <div className="col-xs-4 date">
                                                            <h2>
                                                                {d.start_date && d.start_date.split(/-| /)[2]}
                                                            </h2>
                                                            <h4>
                                                                {
                                                                    months[
                                                                    d.start_date &&
                                                                    d.start_date.split(/-| /)[1]
                                                                        ]
                                                                }
                                                            </h4>
                                                        </div>
                                                        <div className="col-xs-8 event">
                                                            <h4 title={isEnglish
                                                                ? d.meeting_title
                                                                : d.meeting_title_nepali}>
                                                                <NavLink to={`/recent-minutes/${d.id}`}>
                                                                    {isEnglish
                                                                        ? d.meeting_title
                                                                        : d.meeting_title_nepali}
                                                                </NavLink>
                                                            </h4>
                                                            <h6>{isEnglish ? d.venue : d.venue_nepali}</h6>
                                                            <p> Start Date & Time: {d.start_date} </p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
